import React from "react";
import { Button } from 'primereact/button';
import * as styles from './../ImportModal.module.css';

export const ImportModalFooter = ({ uploadRef, setShowImportModal }) => {
  return (
    <>
      <Button
        className={styles.importModalBtnUpload}
        label="Upload"
        onClick={() => uploadRef.current.upload()}
      />

      <Button
        className={styles.importModalBtnCancel}
        label="Cancel"
        severity="secondary"
        onClick={() => {
          uploadRef.current.clear();
          setShowImportModal(false);
        }}
      />
    </>
  );
};
